import React, { Component } from 'react';
import * as d3 from 'd3';
import withTitle from '../components/withTitle';
import chart from './d3/d3-distributionchart';

class DistributionChart extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
  }

  componentDidMount() {
    this.chart = chart()
      .width(this.props.width)
      .height(this.props.height)
      .selected(this.props.selected)
      .statistic(this.props.statistic)
      .assets(this.props.assets)
      .dates(this.props.dates)
      .on('selected', this.props.onSelected);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart, this.props.isResize);
  }

  componentDidUpdate() {
    this.chart
      .width(this.props.width)
      .height(this.props.height)
      .selected(this.props.selected)
      .statistic(this.props.statistic)
      .assets(this.props.assets)
      .dates(this.props.dates);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart, this.props.isResize);
  }

  componentWillUnmount() {
    this.chart
      .cleanup();
  }

  render() {
    return <div ref="chart" style={{ width: '100%' }} />
  }
}

export default withTitle(DistributionChart);



// WEBPACK FOOTER //
// ./src/charts/DistributionChart.js